import Vue from "vue";
import rwd from "./rwd";
import history from "./history";

Vue.mixin(rwd);

Vue.mixin({
  computed: {
    $user() {
      return this.$store.state.app.user;
    },
    isSub() {
      return this.$user.isSub;
    },
    isAdmin() {
      return this.$user.isAdmin;
    },
    thirdParties() {
      return this.$store.state.thirdParty.data;
    },
    showThirdParty(){
      return this.$store.state.thirdParty.data.length > 1;
    },
    $theme() {
      return this.$store.state.app.theme;
    }
  },
});

Vue.mixin(history);
